export const SETUP_GOALS = {
  MAXIMIZE_SPECIFIC_RISK: "maximizeSpecificRisk",
  TARGET_TOTAL_RISK: "targetTotalRisk",
  MIN_VOLATILITY: "minVolatility",
} as const

export const RULES_CONSTRAINTS = {
  TRADE_SWAPS: "tradeSwaps",
  MAX_TURNOVER: "maxTurnover",
  CONCENTRATION: "concentration",
  MAX_TRADE: "maxTrade",
  EQUITY_CHANGE: "equityChange",
  NET_LONG: "netLong",
  PRESERVE_POSITION_DIRECTION: "preservePositionDirection",
  EXPOSURE: "exposure",
  COMPOSITION: "composition",
} as const

export type SetupGoal = (typeof SETUP_GOALS)[keyof typeof SETUP_GOALS]
export type RulesConstraint = (typeof RULES_CONSTRAINTS)[keyof typeof RULES_CONSTRAINTS]

export const FILTER_ACTIONS = {
  CREATE_CUSTOM_SEARCH: "create-custom-search",
} as const

export const FILTER_GROUPS = {
  SAVED_SEARCHES: "Saved Searches",
} as const
